var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payment-fail"},[_c('div',{staticClass:"fail-info-box"},[_c('div',{staticClass:"fail-icon"},[_c('v-icon',{attrs:{"large":"","color":"red","size":"60"}},[_vm._v(" mdi-alert-minus-outline ")])],1),_c('div',{staticClass:"fail-info-text"},[_c('h6',[_vm._v("Payment Failed")]),_c('p',[_vm._v(_vm._s(_vm.msg))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }